import { render, staticRenderFns } from "./emailSettingsLine.vue?vue&type=template&id=55fec204&scoped=true&"
import script from "./emailSettingsLine.vue?vue&type=script&lang=js&"
export * from "./emailSettingsLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fec204",
  null
  
)

export default component.exports